import FeatureBox from '@theme/components/content/FeatureBox'

export default {
  name: 'FeatureBoxes',
  components: { FeatureBox },
  data() {
    return {
      items: this.$t('FeatureBoxes.items'),
    }
  },
}
